import { __assign } from "tslib";
import { clientRequestIdHeader } from './constants';
export var createRequestConfig = function (_a) {
    var _b;
    var aadClientId = _a.aadClientId, objectId = _a.objectId, requestId = _a.requestId, substrateAppId = _a.substrateAppId, tenantId = _a.tenantId, contentType = _a.contentType;
    var headers = (_b = {
            'X-AnchorMailbox': "".concat(objectId, "@").concat(tenantId),
            'X-Office-Application': substrateAppId.toString(),
            'X-RoutingParameter-SessionKey': objectId,
            'X-Ms-ClientAppId': aadClientId
        },
        _b[clientRequestIdHeader] = requestId,
        _b);
    if (contentType) {
        headers = __assign(__assign({}, headers), { 'Content-Type': contentType });
    }
    return {
        headers: headers,
    };
};
//# sourceMappingURL=createRequestConfig.js.map